// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListUserResourceProgressData } from './genericApiResponseListUserResourceProgressData';
import type { GenericApiResponseListUserResourceProgressMessage } from './genericApiResponseListUserResourceProgressMessage';
import type { GenericApiResponseListUserResourceProgressPagination } from './genericApiResponseListUserResourceProgressPagination';
import type { GenericApiResponseListUserResourceProgressError } from './genericApiResponseListUserResourceProgressError';

export interface GenericApiResponseListUserResourceProgress {
  data?: GenericApiResponseListUserResourceProgressData;
  message?: GenericApiResponseListUserResourceProgressMessage;
  pagination?: GenericApiResponseListUserResourceProgressPagination;
  error?: GenericApiResponseListUserResourceProgressError;
  statusCode?: number;
}
